import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  sheetId: null,
  items: [],
  loading: false,
};

const recentChangesSlice = createSlice({
  name: 'recentChanges',
  initialState,
  reducers: {
    recentChangesRequested(state, { payload }) {
      state.loading = true;
      state.sheetId = payload.sheetId;
    },
    recentChangesReceived(state, { payload }) {
      state.sheetId = payload.sheetId;
      state.items = payload.items;
      state.loading = false;
    },
    recentChangesFailed(state) {
      state.loading = false;
    },
    recentChangesCleared() {
      return initialState;
    },
  },
});

export const {
  recentChangesRequested,
  recentChangesReceived,
  recentChangesFailed,
  recentChangesCleared,
} = recentChangesSlice.actions;

export default recentChangesSlice.reducer;
